import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button/Button';
import ButtonLabel from '../../components/Button/ButtonLabel';
import { SBT_SITE_URL } from '../../data/Constants';
import { useState } from 'react';
import { joinWaitingListBirthdate } from '../../services/user';
import { UseFormGetValues } from 'react-hook-form';
import { FormSignUpValues } from '../../data/SignUp/FormSignUp';
import { formatDateToSend } from '../../utils/GenericFunctions';

interface SignUpBirthdateInvalidProps {
  getValues: UseFormGetValues<FormSignUpValues>;
}

export default function SignUpBirthdateInvalid({
  getValues
}: SignUpBirthdateInvalidProps) {
  const [isLoading, setIsloading] = useState(false);

  const navigate = useNavigate();

  function onGoToSBT() {
    window.location.href = SBT_SITE_URL;
  }

  async function onNotifyMe() {
    try {
      setIsloading(true);
      await joinWaitingListBirthdate(
        getValues('userName'),
        getValues('email'),
        formatDateToSend(getValues('birthDate'))
      );
      navigate('/');
    } catch (e) {
      console.error(e);
      navigate('/');
    } finally {
      setIsloading(false);
    }
  }

  function onTermsOfUse() {
    navigate('/termos-de-uso');
  }

  return (
    <div className="card__section">
      <div className="card__top">
        <h2 className="under18__title">Não foi dessa vez</h2>
        <p className="under18__description">
          Ainda não podemos criar uma Conta SBT para menores de 18 anos, mas em
          breve conseguiremos.
        </p>
        <p className="under18__description">
          Para obter mais informações, consulte nossos termos de uso.
        </p>
      </div>

      <div className="button-group">
        <Button
          id="under18-go-to-sbt"
          full
          onClick={onGoToSBT}
          disabled={isLoading}
        >
          <ButtonLabel>Ir para o SBT</ButtonLabel>
        </Button>

        <Button
          customColors="btn-ghost"
          onClick={onNotifyMe}
          disabled={isLoading}
        >
          <ButtonLabel>
            Avise-me quando for possível criar minha Conta SBT
          </ButtonLabel>
        </Button>

        <Button
          customColors="btn-ghost"
          onClick={onTermsOfUse}
          disabled={isLoading}
        >
          <ButtonLabel>Consultar os termos de uso</ButtonLabel>
        </Button>
      </div>
    </div>
  );
}
